<template>
  <section class="fl-section fl-section--cream" style="padding-top: 40px">
    <div class="fl-wrap">
      <!-- Yazı bulunamadı -->
      <div v-if="!post" class="fl-article" style="text-align: center; padding: 60px 0">
        <h1 class="fl-article__title">Yazı bulunamadı</h1>
        <p class="fl-lead" style="margin: 0 auto 28px">
          Aradığın yazı kaldırılmış ya da adresi değişmiş olabilir.
        </p>
        <router-link to="/blog" class="fl-btn fl-btn--primary">
          Tüm yazılara dön
        </router-link>
      </div>

      <template v-else>
        <article class="fl-article">
          <header class="fl-article__hero">
            <router-link to="/blog" class="fl-article__back">
              <i class="mdi mdi-arrow-left"></i> Tüm yazılar
            </router-link>

            <h1 class="fl-article__title">{{ post.title }}</h1>

            <p class="fl-lead" style="color: #6b5b50">{{ post.excerpt }}</p>

            <div class="fl-article__meta">
              <span class="fl-article__badge">{{ post.category }}</span>
              <span>{{ formatDate(post.date) }}</span>
              <span>·</span>
              <span>{{ post.readMinutes }} dakika okuma</span>
            </div>
          </header>

          <!-- İçerik statik ve depoda tutulduğu için v-html güvenlidir. -->
          <div class="fl-prose" v-html="post.body"></div>

          <div class="fl-endcta">
            <div>
              <h3>FantasLink’i denemeye hazır mısın?</h3>
              <p>
                Ücretsiz kayıt ol, ilk linkini oluştur ve açık kampanyalara
                başvur.
              </p>
            </div>
            <a class="fl-btn fl-btn--primary" href="/account/register">
              Ücretsiz Başla
              <i class="mdi mdi-arrow-right"></i>
            </a>
          </div>
        </article>

        <!-- İlgili yazılar -->
        <div style="margin-top: 76px">
          <h2 class="fl-h3" style="margin-bottom: 24px; color: #0a0705">
            İlgili yazılar
          </h2>
          <div class="fl-posts">
            <router-link
              v-for="item in related"
              :key="item.slug"
              :to="'/blog/' + item.slug"
              class="fl-post"
            >
              <div class="fl-post__cover" :style="{ background: item.cover }">
                <i class="mdi" :class="item.icon"></i>
              </div>
              <div class="fl-post__body">
                <div class="fl-post__meta">
                  <span>{{ item.category }}</span>
                  <span>·</span>
                  <span>{{ item.readMinutes }} dk</span>
                </div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.excerpt }}</p>
                <span class="fl-post__more">
                  Yazıyı oku <i class="mdi mdi-arrow-right"></i>
                </span>
              </div>
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import {
  IBlogPost,
  getPostBySlug,
  getRelatedPosts,
} from "../blog-posts";

@Component
export default class BlogDetail extends Vue {
  public post: IBlogPost | undefined = undefined;
  public related: IBlogPost[] = [];

  get slug(): string {
    return String(this.$route.params.slug || "");
  }

  @Watch("$route")
  public onRouteChange() {
    this.load();
  }

  public load() {
    this.post = getPostBySlug(this.slug);
    this.related = getRelatedPosts(this.slug, 3);
    if (this.post) {
      document.title = `${this.post.title} — FantasLink Blog`;
    }
    window.scrollTo(0, 0);
  }

  public formatDate(iso: string): string {
    const months = [
      "Ocak",
      "Şubat",
      "Mart",
      "Nisan",
      "Mayıs",
      "Haziran",
      "Temmuz",
      "Ağustos",
      "Eylül",
      "Ekim",
      "Kasım",
      "Aralık",
    ];
    const d = new Date(iso);
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
  }

  public created() {
    this.load();
  }

  public destroyed() {
    document.title = "FantasLink — İçerik üreticileri için affiliate platformu";
  }
}
</script>
